/**
 * 文书签署
**/

import http from '@/config/httpServer.js'

// 文书材料列表
export const signDocAttachList = (data) => {
    return http({url:'/gzzc/docBook/signDocAttachList'}, data)
}

// 送达文书列表
export const sendDocAttachList = (data) => {
    return http({url:'/gzzc/docBook/sendDocAttachList'}, data)
}
// 未签署文书列表
export const unsignedDocList = (data) => {
    return http({url:'/gzzc/clerkConfirm/unsignedDocList'}, data)
}
// 签名确认信息查询
export const signatureConfirmInfo = (data) => {
    return http({url:'/gzzc/clerkConfirm/signatureConfirmInfo'}, data)
}
// 已签署文书列表
export const signedDocList = (data) => {
    return http({url:'/gzzc/clerkConfirm/signedDocList'}, data)
}
// 发送文书
export const signDocBook = (data,prams) => {
    return http({url:'/gzzc/docBook/signDocBook'}, data)
}
// 刷新token
export const refreshToken = (data) => {
    return http({ url: '/gzzc/user/refreshToken' }, data)
}

// 获取案件（调解室）用户信息列表
export const getMediationRoomUserInfoList = (data) => {
    return http({ url: '/gzzc/room/getMediationRoomUserInfoList' }, data)
}

// 笔录材料列表
export const clerkRecordAttaList = (data) => {
    return http({ url: '/gzzc/clerkRecord/clerkRecordAttaList' }, data)
}

// 文书确认接口（COS）
export const clerkConfirmCos = (documentIds,degree,objectType) => {
    return http({ url: `/gzzc/clerkOpinion/clerkConfirmCos` })
}

// 当事人获取签名二维码
export const clerkConfirmQrCode = (data) => {
    return http({ url: '/gzzc/clerkOpinion/clerkConfirmQrCode' }, data)
}

// 送达文书
export const sendDocBook = (data) => {
    return http({ url: '/gzzc/docBook/sendDocBook' }, data)
}

// 文书模板列表
export const queryDocTempList = (data) => {
    return http({ url: '/gzzc/docBook/queryDocTempList' }, data)
}

// 发送补签
export const complementSignDoc = (data) => {
    return http({ url: '/gzzc/docBook/complementSignDoc' }, data)
}

// 获取预留签名
export const getUserSingnatureList = (data) => {
    return http({ url: '/gzzc/signature/getUserSingnatureList' }, data)
}

// 签名
export const clerkConfirmCos2 = (data) => {
    return http({ url: `/gzzc/clerkOpinion/clerkConfirmCos?documentIds=${data.documentIds}&degree=${data.degree}&objectType=${data.objectType}&meetingId=${data.meetingId}` }, data)
}

// 当事人重签
export const userSignAgain = (data) => {
    return http({ url: '/gzzc/clerkOpinion/userSignAgain' }, data)
}

// 当事人获取签名
export const getUserSign = (data) => {
    return http({ url: '/gzzc/clerkOpinion/getUserSign' }, data)
}

// 获取当事人重签二维码
export const clerkConfirmQm = (data) => {
    return http({ url: `/gzzc/clerkOpinion/clerkConfirmQm?jwtToken=${data.jwtToken}&meetingId=${data.meetingId}`, method: 'get'})
}

// 创建庭审笔录
export const createClerkRecord = (data) => {
    return http({ url: '/gzzc/clerkRecordGzzc/createClerkRecord' }, data)
}

// 直接发送笔录
export const sendClerkRecordGzzc = (data) => {
    return http({ url: 'gzzc/clerkRecordGzzc/sendClerkRecordGzzc' }, data)
}

// 获取用户的签名状态
export const getMeetingUserSignStatus = (data) => {
    return http({ url: 'gzzc/user/getMeetingUserSignStatus' }, data)
}

// 获取公告签署
export const getNoticeDocList = (data) => {
    return http({ url: 'gzzc/clerkConfirm/noticeDocList' }, data)
}

// 调解员删除文书接口
export const delFileByMediatorApi = (data) => {
    return http({ url: 'gzzc/docBook/delDocAttachGzzcSync' }, data)
}
